import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import Error, { FieldError } from './error'

export default class Errors extends Array {
  constructor(array) {
    const errors = !isEmpty(array) ? array.map(e => new Error(e)) : []
    super(...errors)
  }
}

export class FieldErrors extends Array {
  static fromJson(jsonArray) {
    const errors = !isEmpty(jsonArray) ? jsonArray.map(json => FieldError.fromJson(json)) : []
    return new FieldErrors(...errors)
  }
}

export const ERRORS_SHAPE = PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))

export const hasErrorForKey = (errors, key) => errors && errors.find(e => e.key === key)
